import { httpClientIntegration } from "@sentry/browser";
import * as Sentry from "@sentry/vue";
import { useConfigStore } from "@verbleif/shared/src/composables/ConfigStore/useConfigStore";
import app from "@web/core/app";
import router from "@web/core/plugin/router";

if (import.meta.env.PROD) {
  const configStore = useConfigStore();

  if (!configStore.config.value) {
    throw new Error("No config is set.");
  }

  Sentry.init({
    app,
    dsn: "https://b63d8cd9408a4feaa5556aa2f3bb4427@sentry.vitrion.dev/10",
    environment: configStore.config.value.appEnv,
    integrations: [
      httpClientIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
        },
      }),
    ],
    sendDefaultPii: true,
    // The API reports to its own Sentry server. Sending the trace along gives an API error the same trace id as
    // the browser error, so `trace:<id>` finds both. Needs `sentry-trace` and `baggage` in the API's CORS allow list.
    tracePropagationTargets: [
      "app.verbleif.dev",
      "app.verbleif.com",
      "app.staging.verbleif.com",
      /^https:\/\/api\.(staging\.)?verbleif\.(com|dev)\//,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.2,
  });
}
